<template>
  <!-- start 测试结果弹窗容器 -->
  <div class="dialog-box" v-if="open">
    <!-- start 测试结果弹窗 -->
    <div class="dialog">
      <div class="operation-header">
        <div class="closed-container" @click="close">
          <img
            class="popup-close-icon"
            src="@/assets/images/close-popup-icon.png"
          />
        </div>
      </div>
      <div class="line-between"></div>
      <div class="test-result-content">
        <div class="test-result-content-score">
          <!-- start 评分表情显示 -->
          <img
            class="buddha-icon"
            src="@/assets/images/crying-face-icon.png"
            v-if="goodRatingCount < 2"
          />
          <img
            class="buddha-icon"
            src="@/assets/images/xiao-icon.png"
            v-if="goodRatingCount >= 2"
          />
          <!-- end 评分表情显示 -->
          <!-- start 评分图像显示 -->
          <img
            class="score-icon"
            src="@/assets/images/good-score-icon.png"
            v-for="(item, key) in goodRatingCount"
            :key="key"
            style="margin-right: 24px"
            :style="goodRatingCount != 0 && key == 0 ? 'margin-left:26px;' : ''"
          />
          <img
            class="score-icon"
            src="@/assets/images/wrong-score-icon.png"
            v-for="(item, index) in 3 - goodRatingCount"
            :key="index"
            style="margin-right: 24px"
            :style="
              goodRatingCount == 0 && index == 0 ? 'margin-left:26px;' : ''
            "
          />
          <!-- end 评分图像显示 -->
        </div>
        <!-- start 测试弹窗提示 -->
        <div class="test-result-content-hint">
          <template v-if="goodRatingCount < 2">
            很遗憾，未通关！多练习一下再来测试，会有意外的进步哦~
          </template>
          <template v-if="goodRatingCount == 2">
            很遗憾，差一点就通关啦！多练习一下再来测试哦~
          </template>
          <template v-if="goodRatingCount == 3">
            恭喜你，已通关！每天勤奋练习会有意外的收获哦~
          </template>
        </div>
        <!-- end 测试弹窗提示 -->
        <div class="test-result-content-data" style="margin-top: 38px">
          过关条件：速度达到 {{ passRate }} 字/分，正确率达到
          {{ clearanceAccuracy }} %
        </div>
        <div class="test-result-content-data" style="margin-top: 10px">
          你的打字成绩是：每分钟 {{ speed }} 字/分，正确率 {{ accuracy }} %
        </div>
      </div>
      <!-- start 弹窗按钮组 -->
      <div class="btn-group">
        <div class="test-again btn" @click="testAgain">
          再测一次
          <img src="@/assets/images/test-again-icon.png" />
        </div>
        <div class="btn return-exercise" @click="returnExercise">
          回去练习
          <img src="@/assets/images/return-exercise-icon.png" />
        </div>
      </div>
      <!-- end 弹窗按钮组 -->
    </div>
    <!-- end 测试结果弹窗 -->
  </div>
  <!-- end 测试结果弹窗容器 -->
</template>

<script>
export default {
  name: "TestResultPopup",
  data() {
    return {
      goodRatingCount: 0,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    passRate: {
      // 过关速度
      type: Number,
      default: 0,
    },
    clearanceAccuracy: {
      //过关正确率
      type: Number,
      default: 0,
    },
    speed: {
      //速度
      type: Number,
      default: 0,
    },
    accuracy: {
      //正确率
      type: String,
      default: "0",
    },
  },
  watch: {
    accuracy: {
      handler(newval) {
        if (0 <= newval && newval <= 30) {
          this.goodRatingCount = 0;
        }
        if (31 <= newval && newval <= 69) {
          this.goodRatingCount = 1;
        }
        if (70 <= newval && newval <= 94) {
          this.goodRatingCount = 2;
        }
        if (95 <= newval && newval <= 100) {
          this.goodRatingCount = 3;
        }
      },
    },
  },
  methods: {
    // 关闭测试弹窗
    close() {
      this.$emit("close");
    },
    // 再测一次
    testAgain() {
      this.$emit("testAgain");
    },
    // 回去练习
    returnExercise() {
      this.$emit("returnExercise");
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  .dialog {
    width: 740px;
    height: 470px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    outline: none;
    background: #ffffff;
    border: 1px solid #b4b4b4;
    border-radius: 6px 6px 6px 6px;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1607843137254902);
    padding: 0px 10px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-flow: column;
    .operation-header {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .closed-container {
        width: 40px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 0;
        .popup-close-icon {
          width: 12px;
          height: 12px;
          //margin: 8px 0;
        }
      }
      .closed-container:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
    .line-between {
      width: 720px;
      height: 1px;
      background: #ededed;
      border-radius: 0px 0px 0px 0px;
    }
    .test-result-content {
      margin-top: 18px;
      width: 689px;
      height: 339px;
      background: #f8f8f8;
      box-shadow: 0px 2px 2px 1px rgba(0, 0, 0, 0.10196078431372549);
      border: 1px solid #f4f4f3;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      flex-flow: column;
      .test-result-content-score {
        margin-top: 38px;
        display: flex;
        align-items: center;
        .buddha-icon {
          width: 90px;
          height: 90px;
        }
        .score-icon {
          width: 50px;
          height: 48px;
        }
      }
      .test-result-content-hint {
        margin-top: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #d18225;
      }
      .test-result-content-data {
        font-size: 16px;
        font-weight: 400;
        color: #d18225;
      }
    }
    .btn-group {
      margin-top: 24px;
      display: flex;
      .test-again {
        background: linear-gradient(180deg, #80c3fd 0%, #4aa3fc 100%);
      }
      .return-exercise {
        margin-left: 28px;
        background: linear-gradient(180deg, #a1de67 0%, #61be43 100%);
      }
      .btn {
        width: 122px;
        height: 34px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #96cefd;
        font-size: 16px;
        color: #ffffff;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
          margin-top: 4px;
          width: 24px;
          height: 24px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
